import React, { useCallback, useEffect, useState } from 'react'
import { OscLoggedLayout } from '../../layout/OscLoggedLayout'
import img from '../../assets/image 6.svg'
import { HiUserGroup } from 'react-icons/hi'
import { AiFillMessage } from 'react-icons/ai'
import useApi from '../../hooks/useApi'
import { Diagnosis } from '../../types/Diagnosis'
import { Link } from 'react-router-dom'


export const ListDiagnosis = () => {
     
    const api = useApi()

    const [gestao,setGestao] = useState<Diagnosis[]>([])
    const [comunication,setComunication] = useState<Diagnosis[]>([])

    const loadGestao = useCallback(async () => {
        await api.get("/client/diagnoses/gestao").then(res => {
            setGestao(res.data)
        })
        .catch(console.log)
    },[api])

    const loadComunication = useCallback(async () => {
        await api.get("/client/diagnoses/comunicacao").then(res => {
            setComunication(res.data)
        })
        .catch(console.log)
    },[api])

    useEffect(()=>{
        loadComunication()
        loadGestao()
    },[loadComunication , loadGestao])
    return(
        <OscLoggedLayout>
          <div className='w-full flex justify-center -mt-7'>
             <img src={img} alt="jornada" />
          </div> 
          <div className='w-full flex justify-center'>
              <div className='w-6/12 text-center'>
              Comece por aqui. Teste seus níveis de excelência e conheça o perfil da sua OSC.
              </div>
          </div> 
          <div className='w-ful flex flex-col items-center'>
              <div className='w-5/12 mt-6'>
                <div className='flex items-center gap-x-1'>
                    <div className='bg-primary h-8 w-8 rounded flex justify-center items-center'>
                        <HiUserGroup  className='text-lg'/>
                    </div>
                    <div className='text-md font-bold'>Gestão</div>
                </div>
                <div className='pl-5 mt-2 flex flex-col'>
                        {gestao?.map(item => (
                            <Link to={`/osc/responder/${item.id}`} className="cursor-pointer text-base">
                              {item.name}
                          </Link>
                        ))}
                </div>
                <div className='flex items-center gap-x-1 mt-2'>
                    <div className='bg-primary h-8 w-8 rounded flex justify-center items-center'>
                        <AiFillMessage  className='text-lg'/>
                    </div>
                    <div className='text-md font-bold'>Comunicação</div>
                </div>
                <div className='pl-5 mt-2 flex flex-col'>
                        {comunication?.map(item => (
                            <Link to={`/osc/responder/${item.id}`} className="cursor-pointer text-base">
                              {item.name}
                            </Link>
                        ))}
                </div>
              </div>
          </div>
        </OscLoggedLayout>
    )
}